
import VuePicker from 'vue-pickers'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import UserTicket from '@/views/newOrderNetwork/userTicket/index.vue'
import { AppModule, DeviceType } from '@/store/modules/app'
import NetworkIssueTicket from '@/views/newOrderNetwork/networkIssueTicket/index.vue'
import NetworkYunWeiTicket from '@/views/newOrderNetwork/networkYunWeiTicket/index.vue'
import NetworkModifyTicket from '@/views/newOrderNetwork/networkModifyTicket/index.vue'
import { ConfigModule } from '@/store/modules/config'
import { TicketsModule } from '@/store/modules/tickets'

@Component({
  name: 'networkManualWork',
  components: {
    NetworkModifyTicket,
    NetworkYunWeiTicket,
    NetworkIssueTicket,
    UserTicket,
    VuePicker
  }
})
export default class AppMain extends Vue {
  private activeName = ''
  // @Prop({ default: null }) private editForm!: object | null // 传递的编辑数据
  @Prop({ type: Object, default: () => ({}) })
  readonly editForm!: { network_ticket_type?: number };

  mounted() {
    this.setActiveTab()
  }

  @Watch('editForm', { immediate: true, deep: true })
  onEditFormChange() {
    this.setActiveTab()
  }

  private setActiveTab() {
    if (this.isEdit && this.editForm.network_ticket_type !== undefined) {
      const typeToTabMap: Record<number, string> = {
        5: 'user_ticket',
        6: 'network_issue_ticket',
        7: 'network_yunwei_ticket',
        8: 'network_modify_ticket'
      }
      this.activeName = typeToTabMap[this.editForm.network_ticket_type] || 'user_ticket'
    } else {
      this.activeName = 'user_ticket' // 添加模式保持默认
    }
  }

  get isEdit(): boolean {
    return !!this.editForm // editForm 存在就认为是编辑模式
  }

  get classObj() {
    return {
      mobile: this.device === DeviceType.Mobile
    }
  }

  get device() {
    return AppModule.device
  }

  private handleBeforeLeave(tabName: string): boolean {
    if (!this.isEdit) return true // 添加模式允许切换 Tab

    if (this.isTabDisabled(tabName)) {
      this.$message.warning('该选项不可点击！')
      return false // 阻止切换
    }
    return true // 允许切换
  }

  private isTabDisabled(tabName: string): boolean {
    if (!this.isEdit) return false // 添加模式不禁用任何 tab

    const typeToTabMap: Record<number, string> = {
      5: 'user_ticket',
      6: 'network_issue_ticket',
      7: 'network_yunwei_ticket',
      8: 'network_modify_ticket'
    }

    const networkTicketType = this.editForm?.network_ticket_type
    return networkTicketType !== undefined && tabName !== typeToTabMap[networkTicketType]
  }

  private handleClick(tab: object, event: object) {
    ConfigModule.setCommonTypeOptions([]) // 只存 `data.data`
  }

  // 关闭弹框
  private handleClose() {
    TicketsModule.ToggleDialogStatus({
      name: 'editNetworkDialog',
      value: false
    })
  }

  private handleSuccess(res: any) {
    this.$emit('handleSuccess', res)
  }
}
